import { SaleOrder } from "../sale-order.entitiy";
import { SaleOrderTrackDTO } from "./sale-order-track.dto";
import { SaleOrderDto } from "./sale-order.dto";

export class SaleOrderTrackAdapter {
    public convertEntityToDto(saleOrderObject: SaleOrderTrackDTO): SaleOrderTrackDTO {
        const saleOrderTrackDetailsDTO= new SaleOrderTrackDTO;
        saleOrderTrackDetailsDTO.saleOrderId = saleOrderObject.saleOrderId;
        saleOrderTrackDetailsDTO.saleOrderNumber = saleOrderObject.saleOrderNumber;
        // saleOrderTrackDetailsDTO.client = saleOrderObject.client;
        saleOrderTrackDetailsDTO.cost = saleOrderObject.cost;
        saleOrderTrackDetailsDTO.destination = saleOrderObject.destination;
        saleOrderTrackDetailsDTO.customer = saleOrderObject.customer;
        saleOrderTrackDetailsDTO.doc = saleOrderObject.doc;
        saleOrderTrackDetailsDTO.expectedEndDate = saleOrderObject.expectedEndDate;
        // saleOrderTrackDetailsDTO.productCode = saleOrderObject.productCode;
        saleOrderTrackDetailsDTO.orderedDate = saleOrderObject.orderedDate;
        saleOrderTrackDetailsDTO.orderQty = saleOrderObject.orderQty;
        saleOrderTrackDetailsDTO.status = saleOrderObject.status;
        saleOrderTrackDetailsDTO.rmStock = saleOrderObject.rmStock;
        saleOrderTrackDetailsDTO.process = saleOrderObject.process;
        saleOrderTrackDetailsDTO.packing = saleOrderObject.packing;
        saleOrderTrackDetailsDTO.qualityAssurance = saleOrderObject.qualityAssurance;
        saleOrderTrackDetailsDTO.logistics = saleOrderObject.logistics;
        saleOrderTrackDetailsDTO.doc = saleOrderObject.doc;
        saleOrderTrackDetailsDTO.fgStock = saleOrderObject.fgStock;
        
        return saleOrderTrackDetailsDTO;
      }
}